import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import {
    ElementIntegration,
    ElementIntegrationViewData,
    ElementIntegrationPreviewData,
} from 'icreate/common/models/element-integration';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ElementIntegrationService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getByElementId(elementId: string) {
        return await lastValueFrom(
            this.http.get<ElementIntegrationViewData>(`${this.domain}/api/elementIntegration`, {
                headers: this.headers,
                params: { elementId },
            })
        );
    }

    async getByMimicId(mimicId: string) {
        return await lastValueFrom(
            this.http.get<ElementIntegrationPreviewData[]>(`${this.domain}/api/elementIntegration/mimic`, {
                headers: this.headers,
                params: { mimicId },
            })
        );
    }

    async create(integrateData: ElementIntegration) {
        return await lastValueFrom(
            this.http.post<ElementIntegrationViewData>(`${this.domain}/api/elementIntegration`, integrateData, {
                headers: this.headers,
            })
        );
    }

    async update(integrateData: ElementIntegration) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/elementIntegration/${integrateData.id}`, integrateData, {
                headers: this.headers,
            })
        );
    }

    async deleteByElementId(elementId: string) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/elementIntegration/${elementId}`));
    }
}
